export const SEASONAL_ILLUSTRATIONS = {
  easter: { light: "paskekanin", dark: "paskekanin" },
  nationalDayNO: { light: "17-mai", dark: "17-mai-dark" },
  pride: { light: "pride", dark: "pride-dark" },
  christmas: { light: "julekrans", dark: "julekrans" },
  fotballVmPride: { light: "fotball-pride", dark: "fotball-pride" },
  fotballVm: { light: "fotball", dark: "fotball" },
} as const;
